import { render, staticRenderFns } from "./FG.vue?vue&type=template&id=9ae4ccdc&scoped=true&"
import script from "./FG.vue?vue&type=script&lang=js&"
export * from "./FG.vue?vue&type=script&lang=js&"
import style0 from "./FG.vue?vue&type=style&index=0&id=9ae4ccdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae4ccdc",
  null
  
)

export default component.exports